class StickyAddToCart extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.anchor = document.getElementById(`AddToCartAnchor-${this.sectionId}`);
    this.realButton = document.querySelector(
      `#AddToCartAnchor-${this.sectionId} [type="submit"], #AddToCartAnchor-${this.sectionId} button[name="add"]`
    );
    this.stickyButton = this.querySelector(`#StickyAddToCart-${this.sectionId}`);
    this.priceSource = document.getElementById(`price-${this.sectionId}`);
    this.priceTarget = this.querySelector(`#StickyPrice-${this.sectionId}`);

    if (!this.anchor) return;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.classList.remove('is-visible');
        } else if (entry.boundingClientRect.top < 0) {
          this.classList.add('is-visible');
        }
      },
      { threshold: 0 }
    );
    this.observer.observe(this.anchor);

    if (this.stickyButton && this.realButton) {
      this.stickyButton.addEventListener('click', () => {
        this.realButton.click();
      });

      this.buttonObserver = new MutationObserver(() => {
        this.stickyButton.disabled = this.realButton.disabled;
        this.stickyButton.querySelector('span').textContent = this.realButton.disabled
          ? this.stickyButton.dataset.soldOutText
          : this.stickyButton.dataset.addText;
      });
      this.buttonObserver.observe(this.realButton, {
        attributes: true,
        attributeFilter: ['disabled'],
      });
    }

    if (this.priceSource && this.priceTarget) {
      this.priceObserver = new MutationObserver(() => {
        this.priceTarget.innerHTML = this.priceSource.innerHTML;
      });
      this.priceObserver.observe(this.priceSource, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.buttonObserver?.disconnect();
    this.priceObserver?.disconnect();
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);